import React from 'react';
import styled from 'styled-components';


const EsTabTitleBlock = styled.div``;

const EsTabTitle = ({ index, title, selectedIndex }) => {

    let title_class = [" "];

    if (index === selectedIndex) {
        // console.log(index + "=========" + selectedIndex)
        title_class.push('active');
    }

    function handleClick(e) {
        // console.log("onClick !!!");

    }

    return (
        <EsTabTitleBlock>
            <li className={title_class.join(' ')}>
                <button type="button" className="green_border" onClick={handleClick} >{title}</button>
            </li>
        </EsTabTitleBlock>
    );
};

export default EsTabTitle;